export enum CommunicationType {
  Event = "event",
  Standalone = "standalone",
}
